import { getEnv } from 'common/utils';
import { ITrackerConfig } from '@fuxi/eevee-tracker-starter';

const env = getEnv();

export enum EtrackerEnvEnum {
  Dev = 'dev',
  Fat = 'fat',
  Uat = 'uat',
  Prod = 'prod',
}

export const TiangongConfig: ITrackerConfig = {
  pid: 'fuxi-art-pc',
  env: env['VITE_TRACKER_ENV'],
  enableEnv: [EtrackerEnvEnum.Fat, EtrackerEnvEnum.Prod],
  requiredFields: ['pid'],
  // 可以通过plugins来指定接入哪些插件，为空则表示默认接入全部插件，内部逻辑：!plugins, 所以也不能是空数组
  // plugins: ['pv', 'api', 'perf'],
  // pv插件的config设置
  plugin_pv: {
    autoPV: true,
    enableHistory: true,
  },
  // api插件的config设置
  plugin_api: {
    // disableHook: true, // 默认为false，为true则fetch请求和xhr请求均不拦截
    // disableHookFetch: false, // 单独设置是否拦截fetch请求
    // disableHookXHR: false, // 单独设置是否拦截xhr请求
    // disableSendOnSuccess: true, // 目前成功的接口请求，会上报日志，但不会上报response信息，置为true则不上报成功的请求
    sendResponseOnSuccess: true, // 置为true则表示成功的接口请求也上报response信息(在disableSendOnSuccess为false的前提下)，如无必要尽量不要开启
    sendResponseOnSuccessLimit: 10000,
  },
};

export const RecommendConfig: ITrackerConfig = {
  pid: 'fuxi-art-pc',
  env: env['VITE_TRACKER_ENV'],
  enableEnv: [EtrackerEnvEnum.Fat, EtrackerEnvEnum.Prod],
  requiredFields: ['pid', 'uid'],
  plugin_pv: {
    autoPV: false,
    autoLeave: false,
    enableHistory: false,
    enableHash: false,
  },
  plugin_api: {
    sendResponseOnSuccess: true,
    sendResponseOnSuccessLimit: 10000,
  },
};

export const ProjectAdminConfig: ITrackerConfig = {
  pid: 'tiangong-setting',
  env: env['VITE_TRACKER_ENV'],
  enableEnv: [EtrackerEnvEnum.Fat, EtrackerEnvEnum.Prod],
  requiredFields: ['pid'],
  plugin_pv: {
    autoPV: true,
    enableHistory: true,
  },
  plugin_api: {
    sendResponseOnSuccess: true,
    sendResponseOnSuccessLimit: 10000,
  },
};

export const EeveeTrackerConfigMap: Record<'tiangong' | 'recommend' | 'manager' | 'project-admin', ITrackerConfig> = {
  manager: TiangongConfig,
  tiangong: TiangongConfig,
  recommend: RecommendConfig,
  'project-admin': ProjectAdminConfig,
};
